import { makeSearch } from "../../UI/Search/Search";
import VirtualizedAppService from "../../../Services/VirtualizedApp.service";
const makeSearchArgs = {
    loadOptions: (search, options) => VirtualizedAppService.getInternalAppsByQuery(search),
    label: "displayName",
    value: "id",
};
export const VirtualizedAppSearch = makeSearch(makeSearchArgs);
